
export const constants = {
    days_week: [
        {id:'monday', name:'Lundi'},
        {id:'tuesday', name:'Mardi'},
        {id:'wednesday', name:'Mercredi'},
        {id:'thursday', name:'Jeudi'},
        {id:'friday', name:'Vendredi'},
        {id:'saturday', name:'Samedi'},
        {id:'sunday', name:'Dimanche'}
    ]
}


// WEBPACK FOOTER //
// ./src/const.js